
import { TranslationSet } from '../types';

export const baby: TranslationSet = {
  'baby.profile': {
    en: 'Baby Profile',
    ja: '赤ちゃんのプロフィール',
    es: 'Perfil del bebé',
    zh: '宝宝档案',
    fa: 'پروفایل کودک'
  },
  'baby.name': {
    en: 'Baby Name',
    ja: '赤ちゃんの名前',
    es: 'Nombre del bebé',
    zh: '宝宝名字',
    fa: 'نام کودک'
  },
  'baby.birthday': {
    en: 'Birthday',
    ja: '誕生日',
    es: 'Fecha de nacimiento',
    zh: '生日',
    fa: 'تاریخ تولد'
  },
  'baby.gender': {
    en: 'Gender',
    ja: '性別',
    es: 'Género',
    zh: '性别',
    fa: 'جنسیت'
  },
  'baby.gender.male': {
    en: 'Male',
    ja: '男の子',
    es: 'Masculino',
    zh: '男',
    fa: 'پسر'
  },
  'baby.gender.female': {
    en: 'Female',
    ja: '女の子',
    es: 'Femenino',
    zh: '女',
    fa: 'دختر'
  },
  'baby.gender.other': {
    en: 'Other',
    ja: 'その他',
    es: 'Otro',
    zh: '其他',
    fa: 'دیگر'
  },
  'baby.originalHeight': {
    en: 'Original Height',
    ja: '出生時の身長',
    es: 'Altura original',
    zh: '出生时身高',
    fa: 'قد اولیه'
  },
  'baby.originalWeight': {
    en: 'Original Weight',
    ja: '出生時の体重',
    es: 'Peso original',
    zh: '出生时体重',
    fa: 'وزن اولیه'
  }
};
